import { anySignal } from '../util.js';

import type { FetchEnhancer } from '../main.js';

export type TimeoutEnhancer = {
  timeout?: number;
};

/**
 * Sets a timeout on the request given a timeout in milliseconds,
 */
export const timeoutEnhancer: FetchEnhancer<TimeoutEnhancer> = (fetch) => async (info, options) => {
  if (options?.timeout) {
    const timeout = AbortSignal.timeout(options.timeout);
    const signal = options.signal ? anySignal([options.signal, timeout]) : timeout;
    try {
      const result = await fetch(info, { ...options, signal });
      return result;
    } catch (error) {
      // Node seems to throw a different error when the timeout is aborted
      // https://github.com/nodejs/node/issues/43874
      // https://github.com/node-fetch/node-fetch/issues/1462
      if (timeout.aborted) {
        throw timeout.reason;
      }
      throw error;
    }
  }

  return fetch(info, options);
};
